import { Container } from "react-bootstrap";
import fancyBanner from "../../assets/img/inner-banner/Fancy-Diamond-Reports.webp";
import fancyBannerMobile from "../../assets/img/mobile-banner/Fancy-Diamond-Reports.webp";

import "./Certificatedetail.css";
import { Link } from "react-router-dom";
import {
  MdKeyboardDoubleArrowRight,
  MdOutlineKeyboardDoubleArrowRight,
} from "react-icons/md";
import { IoCheckmarkDone } from "react-icons/io5";
import { Helmet } from "react-helmet";
import fulldiamond from "../../assets/img/Icons-Certificate/Full-Diamond.jpg";
import identification from "../../assets/img/Icons-Certificate/Jewelry-Identification.jpg";
import report from "../../assets/img/Icons-Certificate/Lab-Grown-Reports.jpg";
export default function FancyDiamondReports() {
  return (
    <>
      <Helmet>
        {/* Meta tags */}
        <title>
          Fancy Diamond Colored Report | Sreehari Diamond Laboratory{" "}
        </title>
        <meta
          name="description"
          content="Discover how fancy colored diamonds are graded. Understand color intensity, rarity, and value through professional fancy diamond grading reports"
        />
        <meta
          name="keywords"
          content="lab grown diamond certification, best diamond certification in india, Gemstone Identification Lab, Diamond, Gemological Laboratory, Diamond Testing Lab, Diamond Sealing service, Diamond Hologram Stickers, Hologram Stickers for Certificates, Best diamond online services, 4 cs' of diamonds, 4cs education of diamond"
        />
        {/* OG tags */}
        <meta
          property="og:title"
          content="Fancy Diamond Colored Report | Sreehari Diamond Laboratory "
        />
        <meta
          property="og:description"
          content="Discover how fancy colored diamonds are graded. Understand color intensity, rarity, and value through professional fancy diamond grading reports"
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content=" https://sreeharidiamondlab.com/fancy-diamond-reports"
        />
        <meta
          property="og:image"
          content="https://sreeharidiamondlab.com/static/media/Fancy-Diamond-Reports.cd63780b39c8d299107a.webp"
        />
        <meta property="og:site_name" content="sreehari diamond laboratory" />
        {/* Twitter tags */}
        <meta
          name="twitter:title"
          content="Fancy Diamond Colored Report | Sreehari Diamond Laboratory "
        />
        <meta
          name="twitter:description"
          content="Discover how fancy colored diamonds are graded. Understand color intensity, rarity, and value through professional fancy diamond grading reports"
        />
        <meta
          name="twitter:image"
          content="https://sreeharidiamondlab.com/static/media/Fancy-Diamond-Reports.cd63780b39c8d299107a.webp"
        />
        <meta name="twitter:site" content="sreehari diamond laboratory" />
        <link
          rel="canonical"
          href="https://sreeharidiamondlab.com/fancy-diamond-reports"
        />{" "}
      </Helmet>
      <section>
        <Container fluid className="bannersection position-relative p-0">
          <img
            src={window.innerWidth > 568 ? fancyBanner : fancyBannerMobile}
            alt="Service banner"
            className="w-100  h-100 object-fit-cover about-banner-img"
          />
          <h2>From earth to elegance, verified with care</h2>
          <div className="textoverlay pt-5 d-flex flex-column justify-content-center align-items-center position-absolute top-0 w-100 h-100 text-center"></div>
        </Container>
      </section>
      <section className="hologram-section section-spacing-x section-spacing-y pb-0">
        <div className="container-fluid">
          <div className="row">
            <h1 className="heading mb-3 text-center">Fancy Diamond Reports </h1>
          </div>
          <p className="mb-1">
            This report gives shape and cuts, carat weight, and measurement,
            along with color description. A fluorescence picture is included.
          </p>
          <p className="mb-1">
            It is a premium certification document designed for luxury ornaments
            with technical precision.
          </p>
          <p className="mb-1">
            This report gives shape and cut, carat weight, and measurement,
            along with color description. A high resolution picture is included.
          </p>

          <div className="content-para">
            <p>
              <b>Features:</b>
            </p>
            <p>
              <IoCheckmarkDone /> Diamond counts.
            </p>
            <p>
              <IoCheckmarkDone />
              Diamond qualities: cut, color, clarity, and carat weight.
            </p>
            <p>
              <IoCheckmarkDone /> High-resolution imagery of that jewelry.
            </p>
            <p>
              <IoCheckmarkDone /> Fluorescent images.
            </p>
            <p>
              <IoCheckmarkDone /> Unique serial number.
            </p>
            <p>
              <IoCheckmarkDone /> Digital accessibility, ensuring global
              traceability.
            </p>
          </div>
          <div className="contact-us-button mt-lg-4 mb-lg-3 mb-4">
            <Link to="/contact-us">
              Contact Us <MdOutlineKeyboardDoubleArrowRight />
            </Link>
          </div>
        </div>
      </section>

      <section className="section-spacing-x">
        <div className="container-fluid">
          <div className="row mb-5">
            <h2 className="text-center mb-4 heading">Other Certificates</h2>
            <div className="col-lg-4 mb-lg-0 mb-3">
              <div className="service-card text-center border rounded">
                <div className="service-image mx-auto">
                  <img
                    src={fulldiamond}
                    alt="Full Diamond Grading Report | Sreehari Diamond Laboratory"
                    className="img-fluid"
                  />
                </div>
                <Link to="/full-diamond-grading-reports">
                  <h3 className="mb-0">Full Diamond Grading Reports</h3>
                </Link>
                <p className="mb-3">
                  Our diamond grading reports deliver precise analysis of cut,
                  color, clarity, and carat, providing trustworthy certification
                  that reflects the true quality and value of your diamonds.{" "}
                </p>
                <div className="service-read-more mt-lg-0 mt-2 ">
                  <Link to="/full-diamond-grading-reports">
                    Read More
                    <MdKeyboardDoubleArrowRight />
                  </Link>
                </div>
              </div>
            </div>

            <div className="col-lg-4 mb-lg-0 mb-3">
              <div className="service-card text-center border rounded">
                <div className="service-image mx-auto">
                  <img
                    src={identification}
                    alt="Jewelry Identification Report | Sreehari Diamond Laboratory"
                    className="img-fluid"
                  />
                </div>
                <Link to="/diamond-jewelry-reports">
                  <h3 className="mb-0">Diamond Jewelry Reports</h3>
                </Link>
                <p className="mb-3">
                  We offer detailed jewelry identification reports that
                  accurately describe the materials, diamonds, gemstones, and
                  craftsmanship, helping you authenticate and appraise your
                  valuable jewelry pieces.{" "}
                </p>
                <div className="service-read-more mt-lg-0 mt-2">
                  <Link to="/diamond-jewelry-reports">
                    Read More
                    <MdKeyboardDoubleArrowRight />
                  </Link>
                </div>
              </div>
            </div>

            <div className="col-lg-4">
              <div className="service-card text-center border rounded p-2">
                <div className="service-image mx-auto">
                  <img
                    src={report}
                    alt="Lab Grown Report |Sreehari Diamond Laboratory"
                    className="img-fluid"
                  />
                </div>
                <Link to="/lab-grown-reports">
                  <h3 className="mb-0">Lab Grown Reports</h3>
                </Link>
                <p className="mb-3">
                  Get reliable lab-grown diamond reports that verify
                  authenticity, quality, and characteristics, ensuring
                  transparency and confidence when buying or selling synthetic
                  diamonds.{" "}
                </p>
                <div className="service-read-more mt-lg-0 mt-2">
                  <Link to="/lab-grown-reports">
                    Read More
                    <MdKeyboardDoubleArrowRight />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
